module.exports = __webpack_public_path__ + "static/media/fond-nuages-1280.32409056.png";